import { render, staticRenderFns } from "./reactivateEmail.vue?vue&type=template&id=26572940&"
import script from "./reactivateEmail.vue?vue&type=script&lang=js&"
export * from "./reactivateEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports